/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ocr_CompleteInputs */

const en_ocr_complete = /** @type {(inputs: Ocr_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OCR Complete`)
};

const fr_ocr_complete = /** @type {(inputs: Ocr_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OCR complet`)
};

const de_ocr_complete = /** @type {(inputs: Ocr_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OCR abgeschlossen`)
};

const it_ocr_complete = /** @type {(inputs: Ocr_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OCR completo`)
};

const ru_ocr_complete = /** @type {(inputs: Ocr_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OCR Complete`)
};

const es_ocr_complete = /** @type {(inputs: Ocr_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OCR completo`)
};

const zh_cn2_ocr_complete = /** @type {(inputs: Ocr_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OCR 完成`)
};

const ja_ocr_complete = /** @type {(inputs: Ocr_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OCR完了`)
};

const hi_ocr_complete = /** @type {(inputs: Ocr_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ओसीआर पूर्ण`)
};

const pt_pt2_ocr_complete = /** @type {(inputs: Ocr_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OCR completo`)
};

/**
* | output |
* | --- |
* | "OCR Complete" |
*
* @param {Ocr_CompleteInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ocr_complete = /** @type {((inputs?: Ocr_CompleteInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ocr_CompleteInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ocr_complete(inputs)
	if (locale === "de") return de_ocr_complete(inputs)
	if (locale === "it") return it_ocr_complete(inputs)
	if (locale === "ru") return ru_ocr_complete(inputs)
	if (locale === "es") return es_ocr_complete(inputs)
	if (locale === "zh-CN") return zh_cn2_ocr_complete(inputs)
	if (locale === "ja") return ja_ocr_complete(inputs)
	if (locale === "hi") return hi_ocr_complete(inputs)
	if (locale === "pt-PT") return pt_pt2_ocr_complete(inputs)
	return en_ocr_complete(inputs)
});